export default __webpack_public_path__ + "static/media/megaphone.acb1d752.png";